


import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const Exammarks = () => {
  const [marks, setMarks] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
   
  
  const navi=useNavigate()
   useEffect(() => {
    const role = localStorage.getItem("userRole");
    if (role !== "supperadmin") {
      // alert("Access denied. You do not have permission to view this page.");
      navi("/"); // redirect to home or login page
    }
  }, [navi]);
  // Fetch exam marks on component mount
  useEffect(() => {
    const getMark = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API}/questions/getexammark`);
        setMarks(response.data);
      } catch (error) {
        console.error("Error fetching marks:", error);
      }
    };
    getMark();
  }, []);

  // Fetch full student info by UserId
  const handleView = async (userId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/questions/getstudentdetails/${userId}`);
      // console.log(response.data)
      setSelectedStudent(response.data);
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching student details:", error);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedStudent(null);
  };

  // Filter logic
  const filteredMarks = marks.filter((mark) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      mark.name?.toLowerCase().includes(searchLower) ||
      mark.UserId?.toLowerCase().includes(searchLower) ||
      mark.student_id?.toLowerCase().includes(searchLower) ||
      mark.time_taken?.toLowerCase().includes(searchLower)
    );
  });

  return (
    <div>
      <div style={{ marginBottom: "50px" }}>
        <Link to="/" className="logo_image">
          <img src="assets/headimg.jpg" alt="Header" style={{ width: "100%" }} />
        </Link>
      </div>

      {/* 🔍 Search Bar */}
     <div style={{ padding: "10px 20px", display: "flex", justifyContent: "flex-start" }}>
  <input
    type="text"
    placeholder="🔍 Search"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    style={{
      width: "250px",
      padding: "8px 12px",
      fontSize: "14px",
      borderRadius: "8px",
      border: "1px solid #ccc",
      outline: "none",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    }}
  />
</div>


      <div style={{ padding: "20px" ,overflowX:'auto'}}>
        <h2>Student Exam Marks</h2>
        <table border="1" cellPadding="10" cellSpacing="0" style={{ width: "100%", textAlign: "center" }}>
          <thead>
            <tr>
              <th>Name</th>
              <th>User ID</th>
              <th>Student ID</th>
              <th>Time Taken</th>
              <th>Correct Answers</th>
              <th>Wrong Answers</th>
              <th>Attend Question</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {filteredMarks.length > 0 ? (
              filteredMarks.map((mark, index) => (
                <tr key={index}>
                  <td>{mark.name}</td>
                  <td>{mark.UserId}</td>
                  <td>{mark.student_id}</td>
                  <td>{mark.time_taken}</td>
                  <td>{mark.correct_answers}</td>
                  <td>{mark.wrong_answers}</td>
                  <td>{mark.total_questions}</td>
                  <td>
                    <button onClick={() => handleView(mark.UserId)}>View</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">No matching records found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal with student details */}
      {showModal && selectedStudent && (
        <div style={{
          position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
        }}>
          <div style={{
            backgroundColor: "#fff", padding: "20px", borderRadius: "10px", width: "500px", maxHeight: "80%", overflowY: "auto"
          }}>
            <h3>Student Details</h3>
            <p><strong>Father's Name:</strong> {selectedStudent.father_name}</p>
            <p><strong>Phone:</strong> {selectedStudent.phoneNumber}</p>
            <p><strong>School:</strong> {selectedStudent.school}</p>
            <p><strong>Standard:</strong> {selectedStudent.standard}</p>
            <p><strong>Medium:</strong> {selectedStudent.medium}</p>
            <p><strong>Address:</strong> {selectedStudent.address}</p>
            <button onClick={handleCloseModal} style={{ marginTop: "10px" }}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Exammarks;
